import styled from 'styled-components'

export const ModalContainer = styled.div`
  background: #ffffff;
  box-sizing: border-box;
  position: fixed;
  top: -600%;
  left: -600%;
`
